// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__BuZGY","errors":"Errors_errors__1eL8x"};